import React, { Suspense, useState } from 'react';
import { Canvas } from '@react-three/fiber';
import { OrbitControls, Environment, ContactShadows } from '@react-three/drei';
import ShirtModel from './ShirtModel';
import ModelLoader from './ModelLoader';

export default function Scene3D({ frontImage, backImage, color }) {
    const [isModelLoaded, setIsModelLoaded] = useState(false);

    return (
        <div className="w-full h-full min-h-[500px] cursor-grab active:cursor-grabbing relative">
            {/* Show loader while model is loading */}
            {!isModelLoaded && <ModelLoader />}

            <Canvas camera={{ position: [0, 0, 6], fov: 45 }}>
                <ambientLight intensity={0.3} />
                <spotLight position={[10, 10, 10]} angle={0.15} penumbra={1} intensity={0.5} castShadow />
                <pointLight position={[-10, -10, -10]} intensity={0.5} />

                <Suspense fallback={null}>
                    <ShirtModel
                        frontImage={frontImage}
                        backImage={backImage}
                        color={color}
                        onLoad={() => setIsModelLoaded(true)}
                    />
                    <Environment preset="city" />
                    <ContactShadows position={[0, -2, 0]} opacity={0.5} scale={10} blur={1.5} far={4.5} />
                </Suspense>

                <OrbitControls
                    enableZoom={false}
                    minPolarAngle={Math.PI / 2.5}
                    maxPolarAngle={Math.PI / 1.5}
                />
            </Canvas>
        </div>
    );
}
